export default "__VITE_ASSET__tZGsImah__"